import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";
import { ComicRowCard } from "@/components/base/ComicCard";

const latest = [...comics]
  .sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1))
  .slice(0, 8);

export default function LatestUpdates() {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-100 text-primary-700">
            <i className="ri-refresh-line text-lg" />
          </span>
          <h2 className="text-lg font-bold text-foreground-950">最新更新</h2>
        </div>
        <Link
          to="/category/hot"
          className="flex items-center gap-1 whitespace-nowrap text-sm text-primary-700 hover:text-primary-800"
        >
          更多更新
          <i className="ri-arrow-right-s-line" />
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-1 md:grid-cols-2">
        {latest.map((comic) => (
          <ComicRowCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}